export interface Body {
    searchQuery: string
    metrics: Metrics
    keywords: Keyword[]
}

export interface Keyword {
    keyword: string
    keywordId: number
    keywordBid: number | null
    matchType: string
    campaignId: number
    campaignName: string
    adGroupId: number
    adGroupName: string
    metrics: Metrics
}

export interface Metrics {
    spend: number
    conversions: number
    clicks: number
    impressions: number
}

export type ExtraDetails = AddKeywordExtraDetails | AddNegativeKeywordExtraDetails

export enum DeliveredMatchType {
    EXACT = 'Exact',
    PHRASE = 'Phrase',
}

export interface AddKeywordExtraDetails {
    adGroupId: number
    bid: number
    keyword: string
    deliveredMatchType: DeliveredMatchType
}

export interface AddNegativeKeywordExtraDetails {
    sharedSetId: number
    keyword: string
    deliveredMatchType: DeliveredMatchType.EXACT | DeliveredMatchType.PHRASE
}

/**
 *  @name areExtraDetailsAddKeyword
 *  @description Type guard for AddKeywordExtraDetails.
 */
export const areExtraDetailsAddKeyword = (
    extraDetails?: ExtraDetails
): extraDetails is AddKeywordExtraDetails => {
    return (
        extraDetails !== undefined &&
        typeof (extraDetails as AddKeywordExtraDetails).adGroupId !== 'undefined'
    )
}

/**
 *  @name areExtraDetailsAddNegativeKeyword
 *  @description Type guard for AddNegativeKeywordExtraDetails.
 */
export const areExtraDetailsAddNegativeKeyword = (
    extraDetails?: ExtraDetails
): extraDetails is AddNegativeKeywordExtraDetails => {
    return (
        extraDetails !== undefined &&
        typeof (extraDetails as AddNegativeKeywordExtraDetails).sharedSetId !== 'undefined'
    )
}
